import { AxiosError } from 'axios';
import {
  useMutation,
  UseMutationResult,
  useQuery,
  UseQueryResult,
} from 'react-query';
import { User } from '../../@types/user';
import {
  getAccountUsers,
  getUserActivationLink,
  useUserActivationLinkResponse,
} from '../../api/usersApi';

type useUserActivationLinkParams = {
  userId: string;
};

type useAccountUsersParams = {
  accountId: string;
};

export const useUserActivationLink = (): UseMutationResult<
  useUserActivationLinkResponse,
  AxiosError,
  useUserActivationLinkParams
> => {
  return useMutation<
    useUserActivationLinkResponse,
    AxiosError,
    useUserActivationLinkParams
  >(['user-activation-link'], ({ userId }) => getUserActivationLink(userId));
};

export const useAccountUsers = ({
  accountId,
}: useAccountUsersParams): UseQueryResult<User[], AxiosError> => {
  return useQuery<User[], AxiosError>(
    ['account-users', accountId],
    () => getAccountUsers(accountId),
    { enabled: !!accountId },
  );
};
